import { FormattedMessage } from 'react-intl';
import { Box, Image, Text } from '@chakra-ui/react';
import { YStack } from '@shinetools/sunshine-universal';

import ESCDA2025Logo from './assets/ESCDA_2025.png';
import ESCDA2025Photo from './assets/ESCDA_2025_Photo_full.png';

export const ESCDA2025 = () => {
  return (
    <Box
      alignItems="center"
      backgroundImage={`url(${ESCDA2025Photo})`}
      backgroundPosition="center 25%"
      backgroundSize="140%"
      display="flex"
      flex={1}
      justifyContent="flex-start"
    >
      <YStack
        backgroundColor="$grey.200"
        borderRadius={8}
        gap={19.49}
        height={428}
        marginLeft={100}
        padding={48.74}
        width={335}
      >
        <Image height={68} src={ESCDA2025Logo} width={63} />

        <Text
          fontFamily="Value Serif Pro"
          fontSize={33.403}
          textAlign="left"
          variant="primary"
        >
          <FormattedMessage id="login.escda_2025.card.header" />
        </Text>

        <Text fontSize={14.621} textAlign="left" variant="primary">
          <FormattedMessage id="login.escda_2025.card.description" />
        </Text>

        <Text fontSize={9.747} textAlign="left" variant="secondary">
          <FormattedMessage id="login.escda_2025.card.footer" />
        </Text>
      </YStack>
    </Box>
  );
};
